import React from "react";
import { useTranslation } from "react-i18next";
import i18n from "i18n";
import { Spinner } from "components/common";
import { Label } from "components/bootstrap";
import useForwarder from "../../hooks/useForwarder";
const stateToStyle = (state) => {
  switch (state) {
    case "CONNECTED":
      return "default";
    case "DISCONNECTED":
      return "danger";
    default:
      return "warning";
  }
};
const stateToText = (state) => {
  switch (state) {
    case "CONNECTED":
      return i18n.t("forwarder_status_cell.connected", { ns: "enterprise_forwarder" });
    case "DISCONNECTED":
      return i18n.t("forwarder_status_cell.disconnected", { ns: "enterprise_forwarder" });
    default:
      return i18n.t("forwarder_status_cell.unknown", { ns: "enterprise_forwarder" });
  }
};
const ForwarderStatusCell = ({ forwarderId }) => {
  const { t } = useTranslation("enterprise_forwarder");
  const { data, isFetching } = useForwarder(forwarderId != null ? forwarderId : "");
  if (!forwarderId) {
    return /* @__PURE__ */ React.createElement("em", null, t("common.not_available"));
  }
  if (isFetching && !data) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  if (!data) {
    return /* @__PURE__ */ React.createElement("em", null, t("common.not_available"));
  }
  return /* @__PURE__ */ React.createElement(Label, { bsStyle: stateToStyle(data.state) }, stateToText(data.state));
};
export default ForwarderStatusCell;
